import './LanguageSwitcher.css';
import { useLocation, useNavigate } from "react-router-dom";

export default function LanguageSwitcher() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";

  const switchLanguage = (newLang) => {
    let path = location.pathname;

    if (newLang === "ru" && !path.startsWith("/ru")) {
      path = "/ru" + path; // добавляем префикс
    } else if (newLang === "ua" && path.startsWith("/ru")) {
      path = path.replace(/^\/ru/, ""); 
    }

    navigate(path, { replace: true });
  };

  return (
    <div className="language__switcher">
      <button 
        className={`language__button ${currentLang === "ua" ? "active" : ""} mont-r`} 
        onClick={() => switchLanguage("ua")}
      >
        Ua
      </button>
      <div className="lang__border"></div>
      <button 
        className={`language__button ${currentLang === "ru" ? "active" : ""} mont-r`} 
        onClick={() => switchLanguage("ru")}
      >
        Ru
      </button>
    </div>
  );
}
